import { idToken } from "./auth";

let apiUrl = "";
export function setApiUrl(u: string) { apiUrl = u; }

export interface Prototype {
  slug: string;
  title: string;
  description?: string;
  owner: string;
  uploadedAt: string;
  status: "pending" | "ready" | "failed";
  error?: string;
  expiresAt?: number;  // epoch seconds
  kept?: boolean;
}

export interface CreateResponse {
  slug: string;
  uploadUrl: string;
  fields: Record<string, string>;
}

async function req<T>(method: string, path: string, body?: unknown): Promise<T> {
  const res = await fetch(`${apiUrl}${path}`, {
    method,
    headers: {
      Authorization: `Bearer ${idToken()}`,
      ...(body ? { "Content-Type": "application/json" } : {}),
    },
    body: body ? JSON.stringify(body) : undefined,
  });
  if (res.status === 204) return undefined as T;
  const data = await res.json().catch(() => ({}));
  if (!res.ok) throw new Error(data.error ?? `HTTP ${res.status}`);
  return data as T;
}

export const api = {
  list: () => req<{ prototypes: Prototype[] }>("GET", "/prototypes"),
  get: (slug: string) => req<Prototype>("GET", `/prototypes/${slug}`),
  create: (title: string, description?: string) =>
    req<CreateResponse>("POST", "/prototypes", { title, ...(description ? { description } : {}) }),
  del: (slug: string) => req<void>("DELETE", `/prototypes/${slug}`),
  keep: (slug: string) => req<{ kept: boolean }>("PUT", `/prototypes/${slug}/keep`),
  unkeep: (slug: string) => req<{ kept: boolean; expiresAt: number }>("PUT", `/prototypes/${slug}/unkeep`),
};

export async function uploadZip(file: File, presigned: CreateResponse): Promise<void> {
  const form = new FormData();
  // presigned.fields already includes Content-Type and policy — append all fields first
  for (const [k, v] of Object.entries(presigned.fields)) form.append(k, v);
  // file MUST be last
  form.append("file", file);
  const res = await fetch(presigned.uploadUrl, { method: "POST", body: form });
  if (!res.ok) throw new Error(`S3 upload failed: ${res.status}`);
}
